









import Vue from 'vue'

import {Component, Inject, Prop} from 'vue-property-decorator'
import {Observer} from 'mobx-vue'

import {RootStore} from '../../../stores/RootStore'
import { PluginStore } from '../../../stores/Plugins'
import { WebhookStore } from '../../../stores/Webhooks'

import PluginInfo from '../../plugins/PluginInfo.vue'

import FilterList from '../../filter-list/FilterList.vue'

import WebhookItem from './WebhookSelectItem.vue'

@Observer
@Component({components: {FilterList, PluginInfo, WebhookItem}})
export default class PluginSelect extends Vue {
    @Inject()
    private readonly rootStore!: RootStore

    @Prop()
    project!: string

    @Prop({default: ''})
    selected!: string

    plugins!: PluginStore

    webhooks!: WebhookStore

    created() {
        this.plugins = this.rootStore.plugins
        this.webhooks = this.rootStore.webhooks

        this.webhooks.load(this.project)
    }

    itemUpdated() {
        console.log('Updated webhook select')
    }
}
